// extracted by mini-css-extract-plugin
export default {"root":"b6YFIg","blockInfo":"rLlMmO","imgBlock":"SusDL7","img":"b49J60"};